export const rulesList = {
  main: [
    "Я понимаю, что Boostclick — это платформа, а не исполнитель. Задания выполняются независимыми пользователями, доступ к которым предоставляет сервис",
    "Я принимаю, что Boostclick не контролирует результат, не гарантирует его и не несет ответственности за действия исполнителей",
    "Я согласен(-а), что обязан(-а) самостоятельно проверять отчеты",
    <b>Если я не проверю отчет в течение 72 часов, он будет принят автоматически, а средства списаны. Возврат будет невозможен</b>,
  ],
  forRaisePrice: [
    [
      "Я понимаю, что повышение цены делает задание привлекательнее, но",
      <i> не гарантирует, что ее успеет взять добросовестный исполнитель</i>,
    ],
    [
      "Я понимаю, что",
      <i> BOOSTCLICK не несет ответственности за исполнителей</i>,
      " и качество их работы",
    ],
    [
      "Я понимаю, что",
      <i> я должен(-a) самостоятельно проверять и модерировать отчеты</i>,
      " исполнителей",
    ],
    "Я понимаю, что если время на проверку отчетов истечет, исполнитель получит оплату автоматически, и вернуть ее будет невозможно, даже если услуга не оказана",
  ],
  forBotsSeo: [
    [
      "Я понимаю, что",
      <i> перед работой с ПФ</i>,
      " нужно сделать",
      <i> базовую SEO оптимизацию</i>
    ],
    [
      "Я понимаю, что",
      <i> объем закупки ПФ</i>,
      " должен определять SEO специалист",
    ],
    [
      "Я понимаю, что",
      <i> оборудование и софт оплачиваются на месяц</i>,
      " и за него не вернуть деньги",
    ],
    [
      "Я понимаю, чтобы боты находили продвигаемый сайт,",
      <i> поисковые запросы</i>,
      <i> должны быть в ТОП-50</i>,
    ],
    [
      "Я понимаю, что сервис",
      <i> BOOSTCLICK</i>,
      " это инструмент и он",
      <i> не несет ответственности за результаты использования</i>,
    ],
    [
      "Я понимаю, что",
      <i> создавая проект, я беру всю ответственность на себя</i>,
    ],
  ],
  forListeners: [
    "Я подтверждаю, что трек не нарушает законодательство РФ (в том числе запрет на пропаганду наркотиков, экстремизм, нарушение авторских прав)",
    "Я понимаю и принимаю ответственность: штрафы до 1,5 млн ₽, при повторном нарушении — уголовная ответственность (лишение свободы до 2 лет, штраф до 300 тыс ₽ и др.)",
    "Я имею права на этот трек и беру полную ответственность за его содержание"
  ]
};

export const TITLE_LEGAL_CONFIRM = <p>Подтверждаю, что мой проект <br /><b>не нарушает законы Российской Федерации</b></p>;
export const TITLE_ADULT_CONFIRM = <p>Подтверждаю, что мой проект <br /><b>не содержит материалов категории 18+</b></p>;
export const TITLE_POLITICAL_CONFIRM = <p>Подтверждаю, что мой проект <br /><b>не содержит политического контента</b></p>;